const API_BASE = process.env.REACT_APP_API_URL;

// Add advance payment
export const addAdvancePayment = async (paymentData) => {
  try {
    const response = await fetch(`${API_BASE}`, {
      method: 'POST',
      origin: window.location.origin,
      body: JSON.stringify({
        apiKey: "DHRUVDARSHAN",
        action: "addAdvancePayment",
        customerId: paymentData.customerId,
        customerName: paymentData.customerName,
        paymentModes: paymentData.paymentModes,  // { cash, online, oldGold, oldSilver }
        totalAmount: paymentData.totalAmount,
        date: paymentData.date,
        remarks: paymentData.remarks,
        recordedBy: paymentData.recordedBy || "System"
      })
    });
    return await response.json();
  } catch (error) {
    console.error("Error adding advance payment:", error);
    return { success: false, error: error.message };
  }
};

// Get customer advance payments
export const getCustomerAdvancePayments = async (customerId) => {
  try {
    const response = await fetch(`${API_BASE}`, {
      method: 'POST',
      origin: window.location.origin,
      body: JSON.stringify({
        apiKey: "DHRUVDARSHAN",
        action: "getCustomerAdvancePayments",
        customerId: customerId
      })
    });
    return await response.json();
  } catch (error) {
    console.error("Error getting customer advance payments:", error);
    return { success: false, error: error.message };
  }
};

// Use advance for bill
export const advanceUseForBill = async (customerId, billId, billNo, usageAmounts, totalAmount) => {
  try {
    const response = await fetch(`${API_BASE}`, {
      method: 'POST',
      origin: window.location.origin,
      body: JSON.stringify({
        apiKey: "DHRUVDARSHAN",
        action: "useAdvanceForBill",
        customerId: customerId,
        billId: billId,
        billNo: billNo,
        usageAmounts: usageAmounts,  // { cash, online, oldGold, oldSilver }
        totalAmount: totalAmount
      })
    });
    return await response.json();
  } catch (error) {
    console.error("Error using advance for bill:", error);
    return { success: false, error: error.message };
  }
};

// Get all advance payments with filters
export const getAllAdvancePayments = async (filters = {}) => {
  try {
    const response = await fetch(`${API_BASE}`, {
      method: 'POST',
      origin: window.location.origin,
      body: JSON.stringify({
        apiKey: "DHRUVDARSHAN",
        action: "getAllAdvancePayments",
        filters: filters
      })
    });
    return await response.json();
  } catch (error) {
    console.error("Error getting all advance payments:", error);
    return { success: false, error: error.message };
  }
};

// Get advance payment summary for a customer
export const getAdvancePaymentSummary = async (customerId) => {
  try {
    const result = await getCustomerAdvancePayments(customerId);
    if (result.success && result.data) {
      let totalRemaining = 0;
      let totalPaid = 0;
      let totalUsed = 0;
      const advancesByMode = { cash: 0, online: 0, oldGold: 0, oldSilver: 0 };

      result.data.forEach(advance => {
        totalPaid += advance.totalAmount || 0;
        
        // Sum remaining balances by mode
        if (advance.remainingBalances) {
          Object.keys(advance.remainingBalances).forEach(mode => {
            const amount = parseFloat(advance.remainingBalances[mode]) || 0;
            totalRemaining += amount;
            if (advancesByMode[mode] !== undefined) {
              advancesByMode[mode] += amount;
            }
          });
        }
      });

      totalUsed = totalPaid - totalRemaining;

      return {
        success: true,
        data: {
          totalPaid,
          totalUsed,
          totalRemaining,
          advancesByMode
        }
      };
    }
    return result;
  } catch (error) {
    console.error("Error getting advance summary:", error);
    return { success: false, error: error.message };
  }
};